<div class="container">
    <h1 class="principal-title">Radar de eventos futuros</h1>
    <br>
    <div class="row">
        <div class="col-12">
            <h4>¿Qué eventos futuros afectarían el desarrollo nacional?</h4>
            <div id="my_dataviz"></div>
            <div class="row" id="legend_general">
                <div class="col-4">
                    <div id="legend">
                        <h4 style="text-align: center;">Leyenda</h4>
                        <div id="first-legend">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="12" height="12">
                                    <path
                                        d="M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L22.4994 8H18.001L18.0004 13.571L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM22.001 19V21H20.001V19H22.001ZM22.001 10V17H20.001V10H22.001Z" />
                                </svg>
                                <span>Señal débil</span>
                            </div>
                            <div>
                                <svg enable-background="new 0 0 24 24" height="24px" viewBox="0 0 27 27" width="24px"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <path d="M20,0H4C3.4,0,3,0.4,3,1v22c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V1C21,0.4,20.6,0,20,0z M19,22H5V2h14V22z 
                                    M11,15v2h2v-2c2,0,3-1.1,3-3c0-2.2-2-3-4-6c-2,3-4,3.8-4,6C8,13.9,9,15,11,15z" />
                                </svg>
                                <span>Carta salvaje</span>
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                    <path
                                        d="M6 18H18V6H6V18ZM14 20H10V22H8V20H5C4.44772 20 4 19.5523 4 19V16H2V14H4V10H2V8H4V5C4 4.44772 4.44772 4 5 4H8V2H10V4H14V2H16V4H19C19.5523 4 20 4.44772 20 5V8H22V10H20V14H22V16H20V19C20 19.5523 19.5523 20 19 20H16V22H14V20ZM8 8H16V16H8V8Z">
                                    </path>
                                </svg>
                                <span>Tecnología emergente</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div id="tematic">
                        <h4 style="text-align: center;">Temática</h4>
                        <div id="second-legend" style="display: flex;">
                            <div id="first-column">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="12" height="12">
                                        <path
                                            d="M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L22.4994 8H18.001L18.0004 13.571L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM22.001 19V21H20.001V19H22.001ZM22.001 10V17H20.001V10H22.001Z"
                                            fill="#FF5533" />
                                    </svg>
                                    <svg enable-background="new 0 0 24 24" height="24px" viewBox="0 0 27 27"
                                        width="24px" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <path d="M20,0H4C3.4,0,3,0.4,3,1v22c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V1C21,0.4,20.6,0,20,0z M19,22H5V2h14V22z 
                                        M11,15v2h2v-2c2,0,3-1.1,3-3c0-2.2-2-3-4-6c-2,3-4,3.8-4,6C8,13.9,9,15,11,15z"
                                            fill="#FF5533" />
                                    </svg>
                                    <span>Social</span>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="12" height="12">
                                        <path
                                            d="M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L22.4994 8H18.001L18.0004 13.571L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM22.001 19V21H20.001V19H22.001ZM22.001 10V17H20.001V10H22.001Z"
                                            fill="#EFC514" />
                                    </svg>
                                    <svg enable-background="new 0 0 24 24" height="24px" viewBox="0 0 27 27"
                                        width="24px" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <path d="M20,0H4C3.4,0,3,0.4,3,1v22c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V1C21,0.4,20.6,0,20,0z M19,22H5V2h14V22z 
                                        M11,15v2h2v-2c2,0,3-1.1,3-3c0-2.2-2-3-4-6c-2,3-4,3.8-4,6C8,13.9,9,15,11,15z"
                                            fill="#EFC514" />
                                    </svg>
                                    <span>Económico</span>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="12" height="12">
                                        <path
                                            d="M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L22.4994 8H18.001L18.0004 13.571L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM22.001 19V21H20.001V19H22.001ZM22.001 10V17H20.001V10H22.001Z"
                                            fill="#059141" />
                                    </svg>
                                    <svg enable-background="new 0 0 24 24" height="24px" viewBox="0 0 27 27"
                                        width="24px" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <path d="M20,0H4C3.4,0,3,0.4,3,1v22c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V1C21,0.4,20.6,0,20,0z M19,22H5V2h14V22z 
                                        M11,15v2h2v-2c2,0,3-1.1,3-3c0-2.2-2-3-4-6c-2,3-4,3.8-4,6C8,13.9,9,15,11,15z"
                                            fill="#059141" />
                                    </svg>
                                    <span>Ambiental</span>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="12" height="12">
                                        <path
                                            d="M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L22.4994 8H18.001L18.0004 13.571L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM22.001 19V21H20.001V19H22.001ZM22.001 10V17H20.001V10H22.001Z"
                                            fill="#4E87C6" />
                                    </svg>
                                    <svg enable-background="new 0 0 24 24" height="24px" viewBox="0 0 27 27"
                                        width="24px" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <path d="M20,0H4C3.4,0,3,0.4,3,1v22c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V1C21,0.4,20.6,0,20,0z M19,22H5V2h14V22z 
                                        M11,15v2h2v-2c2,0,3-1.1,3-3c0-2.2-2-3-4-6c-2,3-4,3.8-4,6C8,13.9,9,15,11,15z"
                                            fill="#4E87C6" />
                                    </svg>
                                    <span>Tecnológico</span>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="12" height="12">
                                        <path
                                            d="M12.001 3C16.2854 3 20.2201 4.49683 23.3108 6.99607L22.4994 8H18.001L18.0004 13.571L12.001 21L0.69043 6.99671C3.78127 4.49709 7.71632 3 12.001 3ZM22.001 19V21H20.001V19H22.001ZM22.001 10V17H20.001V10H22.001Z"
                                            fill="#9a20e2" />
                                    </svg>
                                    <svg enable-background="new 0 0 24 24" height="24px" viewBox="0 0 27 27"
                                        width="24px" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <path d="M20,0H4C3.4,0,3,0.4,3,1v22c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V1C21,0.4,20.6,0,20,0z M19,22H5V2h14V22z 
                                        M11,15v2h2v-2c2,0,3-1.1,3-3c0-2.2-2-3-4-6c-2,3-4,3.8-4,6C8,13.9,9,15,11,15z"
                                            fill="#9a20e2" />
                                    </svg>
                                    <span>Político</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div id="period">
                        <h4 style="text-align: center;">Período</h4>
                        <div id="third-legend">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="100" height="30" viewBox="0 0 100 30">
                                    <rect x="5" y="5" width="90" height="40" rx="2" ry="2" fill="#F2F3F4" />
                                </svg>
                                <span>2023-2030</span>
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="100" height="30" viewBox="0 0 100 30">
                                    <rect x="5" y="5" width="90" height="40" rx="2" ry="2" fill="#E5E8E8" />
                                </svg>
                                <span>2030-2040</span>
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="100" height="30" viewBox="0 0 100 30">
                                    <rect x="5" y="5" width="90" height="40" rx="2" ry="2" fill="#D5D8DC" />
                                </svg>
                                <span>2040-2050</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div *ngIf="selectedNode" class="custom-modal">
        <div class="custom-modal-content">
            <button class="close-button" (click)="closeModal()">&times;</button>
            <aside class="row">
                <div class="col-12 subtitle-radar mb-3">{{selectedNode.longtitle}}</div>
                <small class="col-4 pb-2"><b>Tipo de evento</b></small>
                <small class="col-8 pb-2">{{selectedNode.tier1}}</small>
                <ng-container *ngIf="selectedNode?.scale?.length>0">
                    <small class="col-4 pb-2"><b>Escala</b></small>
                    <small class="col-8 pb-2">{{selectedNode.scale}}</small>
                </ng-container>
                <small class="col-4 pb-2"><b>Periodo de ocurrencia</b></small>
                <small class="col-8 pb-2">{{selectedNode.period}}</small>
                <small class="col-4 pb-2"><b>Drivers</b></small>
                <small class="col-8 pb-2" [innerHTML]="selectedNode.drivers"></small>
                <ng-container *ngIf="selectedNode?.suppositions?.length>0">
                    <small class="col-4 pb-2"><b>Supuestos de evolución</b></small>
                    <small class="col-8 pb-2" [innerHTML]="selectedNode.suppositions"></small>
                </ng-container>
                <ng-container *ngIf="selectedNode?.actors?.length>0">
                    <small class="col-4 pb-2"><b>Actores involucrados</b></small>
                    <small class="col-8 pb-2" [innerHTML]="selectedNode.actors"></small>
                </ng-container>
                <br>
                <ng-container *ngIf="riskRelations.length>0 || selectedNode?.otherRisksRelated?.length>0">
                    <p class="col-12">Los <b>riesgos</b> vinculados con este evento futuro son:</p>
                </ng-container>
                <ng-container *ngIf="riskRelations.length>0 || selectedNode?.otherRisksRelated?.length>0">
                    <div class="col-12">
                        <ul>
                            <ng-container *ngIf="riskRelations.length>0">
                                <li *ngFor="let r of riskRelations"><a class="underline"
                                        href="../ficha/{{r.code}}">{{r.shorttitle}}</a></li>
                            </ng-container>
                            <ng-container *ngIf="selectedNode?.otherRisksRelated?.length>0">
                                <div [innerHTML]="selectedNode.otherRisksRelated"></div>
                            </ng-container>
                        </ul>
                    </div>
                </ng-container>
                <br>
                <br>
                <ng-container *ngIf="oppRelations.length>0 || selectedNode?.otherOppsRelated?.length>0">
                    <p class="col-12">Las <b>oportunidades</b> vinculadas con este evento futuro son:</p>
                </ng-container>
                <ng-container *ngIf="oppRelations.length>0 || selectedNode?.otherOppsRelated?.length>0">
                    <div class="col-12">
                        <ul>
                            <ng-container *ngIf="oppRelations.length>0">
                                <li *ngFor="let r of oppRelations"><a class="underline"
                                        href="../ficha/{{r.code}}">{{r.shorttitle}}</a></li>
                            </ng-container>
                            <ng-container *ngIf="selectedNode?.otherOppsRelated?.length>0">
                                <div [innerHTML]="selectedNode.otherOppsRelated"></div>
                            </ng-container>
                        </ul>
                    </div>
                </ng-container>

                <div class="col-12">Lea más acerca de este evento aquí:</div>
                <div class="col-12 doc-color-button">
                    <div class="div-button-download">
                        <a href="../ficha/{{selectedNode.code}}" target="_blank" style="cursor: pointer;">
                            <strong class="">Ficha completa</strong>
                        </a>
                    </div>
                </div>
            </aside>
        </div>
    </div>
    <br>
    <ng-container *ngIf="tier1s">
        <div class="row py-3" *ngFor="let t1 of tier1s">
            <h3 class="col-12 subtitle-trends">{{t1.longtitle}}</h3>
            <div class="col-md-3">
                <ng-container *ngIf="t1.img!=null">
                    <ng-container *ngIf="t1.img.substring(1,6)==='upload'">
                        <img class="img-fluid img-signal" src="{{URL}}{{t1.img}}" alt="{{t1.shorttitle}}">
                    </ng-container>
                    <ng-container *ngIf="t1.img.substring(1,6)!=='upload'">
                        <img class="img-fluid img-signal" src="{{t1.img}}" alt="{{t1.shorttitle}}">
                    </ng-container>
                </ng-container>
            </div>
            <div class="col-md-9">
                <p class="intro-ev" [innerHTML]="t1.summary"></p>
                <div class="">
                    <ng-container *ngIf="tier3s">
                        <table class="table table-sm table-striped">
                            <thead class="thead-dark">
                                <tr class="tr-pointer">
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Temática</th>
                                    <th scope="col" class="d-none d-md-table-cell">Actualización</th>
                                    <th scope="col">Ficha</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="tr-policy" *ngFor="let o of tier3s">
                                    <ng-container *ngIf="o.idtier1 == t1.id">
                                        <td>{{o.longtitle}}</td>
                                        <ng-container *ngFor="let t of tematics">
                                            <td class="" *ngIf="o.idtematic == t.id">
                                                {{t.title}}
                                            </td>
                                        </ng-container>

                                        <td class="d-none d-md-table-cell">{{o.lastUpdated | date:'mediumDate'}} </td>
                                        <td class="text-center">
                                            <a class="a-signal" href="../ficha/{{o.code}}" target="_blank">
                                                <i class="fa fa-external-link"></i>
                                            </a>
                                        </td>
                                    </ng-container>
                                </tr>
                            </tbody>
                        </table>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>
</div>